import {BACKEND_URL} from "../../../configs";
import {globalFetchConfig} from "../../../api/apiConfiguration";
import {DownloadedFile, readErrorMessage, readFileName} from "../../../utils/fileTransferUtils";

export interface OpeningHoursImportResult {
    rowsRead: number;
    schedulesUpdated: number;
    schedulesUnchanged: number;
}

const BULK_UPDATE_URL = `${BACKEND_URL}/api/private/bulk-update`;

export const exportOpeningHours = async (): Promise<DownloadedFile> => {
    const response = await globalFetchConfig(`${BULK_UPDATE_URL}/opening-hours/export`, {method: "GET"});

    if (!response.ok) {
        throw new Error(await readErrorMessage(response, "Failed to download the opening hours"));
    }

    return {
        fileName: readFileName(response.headers.get("Content-Disposition"), "opening-hours.csv"),
        blob: await response.blob()
    };
};

export const importOpeningHours = async (file: File): Promise<OpeningHoursImportResult> => {
    const response = await globalFetchConfig(`${BULK_UPDATE_URL}/opening-hours/import`, {
        method: "POST",
        headers: {"Content-Type": "text/csv"},
        body: file
    });

    if (!response.ok) {
        throw new Error(await readErrorMessage(response, "Failed to upload the opening hours"));
    }

    return await response.json();
};
